import ModuleContent from "features/shared/layout/content/ModuleContent";
import Header from "features/shared/layout/header/Header";
import React from "react";
import { useTranslation } from "react-i18next";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import ContractProcessSection from "./sections/ContractProcessSection";
import ContractProcessDetail from "./pages/ContractProcessDetail";


const ContractProcess = () => {
  let match = useRouteMatch();
  const { t } = useTranslation(["shared\\moduleNames"]);

  return (
    <Switch>
      <Route path={`${match.path}/:id`} component={ContractProcessDetail} />
      <Route path={match.path}>
        <Header title={t("contractProcess.title")} includeBreadcrumbs />
        <ModuleContent>
          <ContractProcessSection />
        </ModuleContent>
      </Route>
    </Switch>
  );
};

export default ContractProcess;
